import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const SettingIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M12.355 8.702c.027-.225.045-.459.045-.702 0-.243-.018-.477-.054-.702l1.521-1.188a.372.372 0 0 0 .09-.459l-1.44-2.493a.366.366 0 0 0-.44-.162l-1.792.72a5.273 5.273 0 0 0-1.215-.702L8.8 1.106A.36.36 0 0 0 8.44.8H5.56a.35.35 0 0 0-.35.306l-.27 1.908c-.442.18-.847.423-1.216.702l-1.79-.72a.356.356 0 0 0-.442.162L.052 5.651a.349.349 0 0 0 .09.46l1.521 1.187A4.524 4.524 0 0 0 1.6 8c0 .234.018.477.054.702L.134 9.89a.372.372 0 0 0-.09.459l1.44 2.493c.09.162.278.216.44.162l1.791-.72c.378.288.774.522 1.215.702l.27 1.908c.036.18.18.306.36.306h2.88c.18 0 .333-.126.351-.306l.27-1.908c.441-.18.846-.423 1.215-.702l1.791.72c.162.063.351 0 .441-.162l1.44-2.493a.349.349 0 0 0-.09-.459l-1.503-1.188zM7 10.7A2.708 2.708 0 0 1 4.3 8c0-1.485 1.215-2.7 2.7-2.7S9.7 6.515 9.7 8 8.485 10.7 7 10.7z"
    />
  </svg>
);

SettingIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

SettingIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(14, 16),
};

export default SettingIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/setting.js